import { Breadcrumb as Bread } from 'antd';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { manaRouter } from '../router';


const Breadcrumb = () => {
  const [arr, setArr] = useState<string[]>([]);
  const location = useLocation();
  const path = location.pathname;

  useEffect(() => {
    const a: string[] = [];
    manaRouter.forEach(i => {
      if (path.includes(String(i.path))) {
        i.meta?.name && a.push(i.meta?.name as string);
        if (i.children) {
          const item = i.children.find(j => path.includes(String(j.path)));
          if (item) {
            item.meta?.name && a.push(String(item.meta?.name));
          }
        }
      }
      setArr(a);
    });
  }, [location]);
  return (
    <Bread style={{marginBottom: '20px'}}>
      <Bread.Item>首页</Bread.Item>
      {
        arr.map(i => <Bread.Item key={i}>{i}</Bread.Item>)
      }
    </Bread>
  );
};


export default Breadcrumb;